import { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";

export default function TrackRedirect() {
  const { code } = useParams();
  const loc = useLocation();
  useEffect(() => {
    window.location.replace(`/api/public/click/${code}${loc.search || ""}`);
  }, [code, loc.search]);
  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--tf-bg)]">
      <div className="h-10 w-10 animate-spin rounded-full border-2 border-slate-700 border-t-emerald-500" />
    </div>
  );
}
